import React from 'react';
import TopHeaderContainer from '../../organisms/RTCC/topHeaderContainer';
import { FooterContainer } from '../../organisms/RTCC/footerContainer';
import { TopContainer } from '../../organisms/RTCC/topContainer';
import ScrollToTop from '../../atoms/RTCC/scrollToTop';
import { MemberShipOutsideHoursCheck } from '../../../util/memberShipOutsideHoursCheck';


class TopTemplate extends React.Component {

    render() {
        return (
            <div>
                <ScrollToTop />
                <MemberShipOutsideHoursCheck
                    state={this.props.state}
                    setOutsideHoursFlg={this.props.setOutsideHoursFlg}
                    setMenuTitle={this.props.setMenuTitle}
                />
                <TopHeaderContainer Label categoryLabel1={"予約カテゴリ"} categoryLabel2={"CATEGORIES"} />
                <TopContainer
                    setOutsideHoursFlg={this.props.setOutsideHoursFlg}
                    setMenuTitle={this.props.setMenuTitle}                 
                />
                <FooterContainer />
            </div>
        )
    }
}
export default TopTemplate;